<template>
  <section>
    <!-- Header -->
    <left-menu />

    <button-back v-if="routeBack" :btnRoute="routeBack"/>
    <modal-change-linkedin :user-obj="dataEmployee" :actionLinkedin.sync="linkedinEmit"/>
    <modal-change-whats :user-obj="dataEmployee" :actionWhats.sync="whatsEmit"/>

    <div id="mainContent" class="perfil-by-manager">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Perfil do Funcionário</h1>
        </div>

        <loading-page v-if="loading" />

        <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-profile-user">
              <div class="user-photo">
                <img v-if="dataEmployee.profilePhoto" v-bind:src="dataEmployee.profilePhoto" class="img-responsive photo" alt="Usuário">
                <img v-else src="/src/assets/img/user-default.png" class="img-responsive photo" alt="Usuário">
              </div>

              <div class="data-user">
                <p class="name">#{{dataEmployee.code}} {{dataEmployee.userName}}</p>
                <p class="email">{{dataEmployee.officeMe}}</p>
              </div>

              <button v-on:click="sendWelcomeToEmail()">
                <ion-icon name="mail-outline"></ion-icon>
                <span>Enviar e-mail de boas-vindas</span>
              </button>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-complement-info">
              <p class="title">Informações Pessoais</p>
              <p>CPF: <strong v-bind:title="dataEmployee.cpf | cpfOrCnpj">{{dataEmployee.cpf | cpfOrCnpj}}</strong></p>
              <p>E-mail: <strong v-bind:title="dataEmployee.email">{{dataEmployee.email}}</strong></p>
              <p>Telefone: <strong v-bind:title="dataEmployee.phone">{{dataEmployee.phone | phone}} <span v-if="!dataEmployee.phone">-</span></strong></p>
              <p>WhatsApp: <strong v-bind:title="dataEmployee.cellPhoneNumber">{{dataEmployee.cellPhoneNumber | phone}} <span v-if="!dataEmployee.cellPhoneNumber">-</span></strong></p>
              <p>Data de nascimento: <strong v-bind:title="dataEmployee.birthday | formatDate">{{dataEmployee.birthday | formatDate}} <span v-if="!dataEmployee.birthday">-</span></strong></p>
              <p>Último acesso: <strong v-bind:title="dataEmployee.lastAcess | formatDateHours">{{dataEmployee.lastAcess | formatDateHours}}</strong></p>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-complement-info">
              <p class="title">Informações de Trabalho</p>
              <p>Cargo: <strong v-bind:title="dataEmployee.officeMe">{{dataEmployee.officeMe}}</strong></p>
              <p>Equipe: <strong v-bind:title="dataEmployee.teamName">{{dataEmployee.teamName}}</strong></p>
              <p>Turno: <strong v-bind:title="dataEmployee.workShiftTurn">{{dataEmployee.workShiftTurn}}</strong></p>
              <p>Data de admissão: <strong v-bind:title="dataEmployee.addmissionDate">{{dataEmployee.addmissionDate}}</strong></p>
              <p>Data de cadastro: <strong v-bind:title="dataEmployee.createdAt">{{dataEmployee.createdAt}}</strong></p>
              <p>Linkedin:
                <strong v-bind:title="dataEmployee.linkedInUrl">
                  <a v-if="dataEmployee.linkedInUrl" v-bind:href="dataEmployee.linkedInUrl" target="_blank">Visualizar</a>
                  <span v-else>-</span>
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div v-if="!loadingBoxes && !loading" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-balance-info">
              <div class="title">
                <h4>Saldo de horas acumulado</h4>
              </div>
              <p class="sub-text">desde a admissão/inícios</p>
              <div class="line"></div>
              <div class="content-balance">
                <div v-bind:class="{'bg-color-green': isExtra, 'bg-color-red': isExtra === false}">
                  <ion-icon name="time-outline"></ion-icon>
                </div>
                <p><span v-bind:class="{'color-green': isExtra, 'color-red': isExtra === false}">{{ totalHours }}</span> horas</p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-balance-info">
              <div class="title">
                <h4>Ocorrências</h4>
              </div>
              <p class="sub-text">dos últimos 30 dias</p>
              <div class="line"></div>
              <div class="content-balance">
                <div class="bg-color-yellow">
                  <ion-icon class="ocurrence" name="warning-outline"></ion-icon>
                </div>
                <p><strong>{{ totalOcurrences }}</strong> ocorrências</p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <div class="col-xs-12 col-sm-12 col-md-12 box-balance-info">
              <div class="title">
                <h4>Faltas</h4>
              </div>
              <p class="sub-text">dos últimos 30 dias</p>
              <div class="line"></div>
              <div class="content-balance">
                <div class="bg-color-red">
                  <ion-icon name="close-circle-outline"></ion-icon>
                </div>
                <p><strong>{{ totalFaults }}</strong> faltas</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading && !loadingTable" class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-list-hours-user">
            <div class="infos">
              <h2 class="certa">Histórico</h2>
              <p class="nunito txt-help"></p>

              <div class="select-date">
                <div>
                  <p class="nunito">Mostrar período de</p>
                  <datepicker ref="programaticOpen1" v-model="initialDate" :language="ptBR" :format="customFormatter"/>
                  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                </div>
                <div>
                  <p class="nunito at">até</p>
                  <datepicker ref="programaticOpen2" v-model="finalDate" :language="ptBR" :format="customFormatter"/>
                  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                </div>
                <div class="search-btn">
                  <button v-on:click="searchRequestDate()" class="btn-search-period certa" type="submit">Pesquisar</button>
                </div>
              </div>
            </div>

            <div class="table-responsive offset-top-50">
              <table class="table table-clean">
                <thead>
                <tr>
                  <th class="certa">Data</th>
                  <th class="certa">Status</th>
                  <th class="certa">Registros</th>
                  <th class="certa">Intervalo</th>
                  <th v-if="showPause" class="certa">Pausa</th>
                  <th class="certa">Horas necessárias</th>
                  <th class="certa">Horas trabalhadas</th>
                  <th class="certa">Saldo</th>
                  <th v-if="justifyExtra" class="certa">Justificativa H.E</th>
                  <th class="certa">Fotos</th>
                  <th class="certa">Ação</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="pu in allPointUser.list">
                  <td class="nowrap">
                    <p class="offset-top-20 nunito day-info">{{pu.date | formatDate}} <span>{{pu.date |strDay}}</span></p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.userPointDayStatus === 0" class="status-default">{{pu.status}}</span>
                      <span v-if="pu.userPointDayStatus === 1" class="status-interval">{{pu.status}}</span>
                      <span v-if="pu.userPointDayStatus === 2" class="status-work">{{pu.status}}</span>
                      <span v-if="pu.userPointDayStatus === 3" class="status-done">{{pu.status}}</span>
                      <span v-if="pu.userPointDayStatus === 4" class="status-incorrect">{{pu.status}}</span>
                      <span v-if="pu.userPointDayStatus === 5" class="status-fault">{{pu.status}}</span>
                    </p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.listPoint.length">{{pu.listPoint.length}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.totalInterval">{{pu.totalInterval}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td v-if="showPause">
                    <p class="offset-top-20 nunito">
                      <span v-if="showPause">{{pu.totalInPause}}</span>
                      <span v-if="!pu.totalInPause">-</span>
                    </p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.workingDayTotal">{{pu.workingDayTotal}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.totalHours">{{pu.totalHours}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td>
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.balance">{{pu.balance}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td v-if="justifyExtra">
                    <p class="offset-top-20 nunito">
                      <span v-if="pu.justify">{{pu.justify | limitTo(20)}}</span>
                      <span v-else>-</span>
                    </p>
                  </td>
                  <td class="no-wrap">
                    <div v-if="pu.listPoint.length && pu.totalPhotos" class="img-point">
                      <img v-if="(pu.totalPhotos >= 2 && index <= 1) && p.image || (pu.listPoint.length <= 2 && p.image)" v-for="(p, index) in pu.listPoint" v-bind:src="p.image" alt="foto" class="photo-user">
                      <div v-if="pu.totalPhotos >= 3" class="show-more-photos">
                        <p>+{{pu.listPoint.length - 2}}</p>
                        <div class="view-more-photos" v-bind:style="{'width': (pu.listPoint.length - 2) * 90 + 'px'}">
                          <img v-if="index >= 2 && p.image" v-for="(p, index) in pu.listPoint" v-bind:src="p.image" alt="foto">
                        </div>
                      </div>
                    </div>
                    <p v-else class="offset-top-20 nunito">-</p>
                  </td>
                  <td>
                    <div class="view-more-table">
                      <p class="nunito">
                        <i class="fa fa-ellipsis-h more" aria-hidden="true"></i>
                      </p>
                      <div class="view-more-links">
                        <a v-bind:href="'/detalhes-do-dia/2/' + pu.id" target="_blank" class="nunito"><i class="fa fa-eye eye" aria-hidden="true"></i> Ver Detalhes</a>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import loadingPage from "../../components/loadingPage";
  import loadingTable from "../../components/loadingTable";
  import buttonBack from "../../components/buttonBack";
  import modalChangeLinkedin from "../../modals/perfilChangeLinkedin";
  import modalChangeWhats from "../../modals/perfilChangeWhats";

  import vueFooter from "../../components/footer";
  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import swal from 'sweetalert';

  import {
    DATA_EMPLOYER,
    PROFILE_POINT,
    EMAIL_WELCOME,
    PROFILE_HOURS
  } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";

  export default {
    name: "user-perfil",
    components: {
      modalChangeLinkedin,
      modalChangeWhats,
      leftMenu,
      loadingPage,
      loadingTable,
      buttonBack,
      vueFooter,
      datepicker
    },
    data() {
      return {
        linkedinEmit: '',
        whatsEmit: '',
        routeBack: '',
        failDataTable: false,
        showPause: JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause,
        ptBR: ptBR,
        loading: false,
        loadingTable: false,
        loadingBoxes: false,
        initialDate: new Date().setDate(new Date().getDate() - 15),
        finalDate: new Date(),
        dataEmployee: '',
        justifyExtra: false,
        allPointUser: {
          list: []
        },
        isExtra: null,
        totalHours: 0,
        totalFaults: 0,
        totalOcurrences: 0
      }
    },
    methods: {
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      searchRequestDate () {
        if (this.initialDate && this.finalDate) {
          this.loading = true;
          this.allPointUser = { list: [] };

          this.employerPoint();
        }
      },
      sendWelcomeToEmail() {
        swal({
          text: "Deseja enviar por e-mail como usar o aplicativo MarQPonto para o funcionário?\n\n",
          title: "E-mail de Como Usar",
          type: "success",
          button: {
            text: "Confirmar",
            closeModal: true,
          },
          html : true,
          showCancelButton: true,
        }).then(pass => {
          if (!pass) throw null;

          swal.stopLoading();
          swal.close();

          REQUEST_SERVICE.get(EMAIL_WELCOME + "?u=" + this.$route.params.idUser).then((response) => {
            UTIL_SERVICE.console("RESULT EMAIL_WELCOME:", response.data);

            swal("Sucesso!", "E-mail enviado com sucesso.", "success");
          }).catch(reason => { });
        }).catch(err => {
          swal.stopLoading();
          swal.close();
        });
      },
      employerInfo() {
        this.loading = true;
        REQUEST_SERVICE.get(DATA_EMPLOYER + "/" + this.$route.params.idUser).then((response) => {
          UTIL_SERVICE.console("RESULT DATA_EMPLOYER:", response.data);

          this.dataEmployee = response.data;
          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      employerPoint() {
        this.loadingTable = true;
        this.failDataTable = false;

        let url = PROFILE_POINT + "?u=" + this.$route.params.idUser;
        url += "&initDate=" + moment(this.initialDate).format("YYYY-MM-DD");
        url += "&endDate=" + moment(this.finalDate).format("YYYY-MM-DD");

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT PROFILE_POINT:", response.data);

          this.allPointUser = response.data;
          if (response.data) {
            if (response.data.justifyExtra) {
              this.justifyExtra = true;
            }
          }

          this.allPointUser.list.map((value, index) => {
            value.totalPhotos = 0;
            value.listPoint.map((v) => {
              if (v.image) value.totalPhotos++;
            });
          });

          this.loading = false;
          this.loadingTable = false;
        }).catch(reason => {
          this.loading = false;
          this.loadingTable = false;
          this.failDataTable = true;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getHoursUser(value) {
        this.loadingBoxes = true;
        let url = `${PROFILE_HOURS}${value}`;
        url += `?i=${this.$route.params.idUser}`;

        switch (value) {
          case 'hours':
            url += `&all=true`;
            break;
          case 'faults':
            url += `&days=30`;
            break;
          case 'ocurrences':
            url += `&days=30`;
            break;
        }

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT PROFILE_HOURS:", response.data);

          switch (value) {
            case 'hours':
              this.totalHours = response.data.balance;
              this.isExtra = response.data.isExtra;
              break;
            case 'faults':
              this.totalFaults = response.data.value;
              break;
            case 'ocurrences':
              this.totalOcurrences = response.data.value;
              break;
          }
          this.loadingBoxes = false;
        }).catch(reason => {
          this.loadingBoxes = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
    },
    beforeMount() {
      if (this.$route.params.routeB === '1') {
        this.routeBack = "/gestao-de-ponto";
      } else if (this.$route.params.routeB === '3') {
        this.routeBack = null;
      } else if (this.$route.params.routeB === '5') {
        this.routeBack = "/lista-de-ferias-afastamento";
      } else {
        this.routeBack = "/minha-equipe";
      }

      this.employerInfo();
      this.employerPoint();
      this.getHoursUser('hours');
      this.getHoursUser('faults');
      this.getHoursUser('ocurrences');
    },
    watch: {
      linkedinEmit: function(response) {
        this.dataEmployee.linkedInUrl = response.value;
      },
      whatsEmit: function(response) {
        this.dataEmployee.cellPhoneNumber = response.value;
      }
    }
  }
</script>

<style lang="scss">
.box-profile-user {
  min-height: 252px;
  background: var(--bodyContrast);
  border-radius: 10px;
  padding: 16px;

  .user-photo {
    width: 125px;
    height: 125px;
    background: var(--bodyColor);
    border-radius: 100%;
    display: block;
    margin: 0 auto 10px;

    img {
      width: 125px;
      height: 125px;
      border-radius: 100%;
      object-fit: cover;
    }
  }

  .data-user {
    display: block;
    text-align: center;

    .name {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      text-align: center;
      color:var(--titleBox);
      margin: 0;
    }

    .email {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: var(--iconSide);
      margin: 0;
    }
  }

  button {
    display: block;
    margin: 8px auto 0;
    background: transparent;
    border: none;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: var(--linkColor);
    cursor: pointer;

    ion-icon {
      font-size: 18px;
      position: relative;
      top: 4px;
      display: inline-block;
      margin-right: 4px;
    }
  }
}

.box-complement-info {
  min-height: 252px;
  background: var(--bodyContrast);
  border-radius: 10px;
  padding: 16px;

  .view-link {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #2F23D6;
    cursor: pointer;
  }

  .title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: var(--titleBox);
    margin: 0 0 20px;
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: var(--iconSide);
  }
}

.box-balance-info {
  min-height: 150px;
  background: var(--bodyContrast);
  border-radius: 10px;
  padding: 16px;

  .title {
    h4 {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      color: var(--titleBox);
      margin: 0;
    }
  }

  .sub-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    margin: 2px 0 10px;
    color: #7F8897;
  }

  .line {
    width: 100%;
    height: 1px;
    margin-bottom: 10px;
    background: var(--bodyColor);
  }

  .content-balance {
    div {
      display: inline-block;
      width: 42px;
      height: 42px;
      background: var(--bodyColor);
      border-radius: 100%;
      text-align: center;
      margin-right: 12px;

      ion-icon {
        font-size: 28px;
        color: #ffffff;
        position: relative;
        top: 7px;
      }

      .ocurrence {
        color: #3A424E;
        top: 6px;
      }
    }

    .bg-color-green {
      background: var(--greenColor);
    }

    .bg-color-red {
      background: var(--redColor);
    }

    .color-red {
      color: var(--redColor);
    }

    .color-green {
      color: var(--greenColor);
    }

    .bg-color-yellow {
      color: var(--iconSide);
      background: var(--yellowColor2);
    }

    .bg-color-red {
      background: var(--redColor);
    }

    p {
      display: inline-block;
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-size: 21px;
      color: var(--iconSide);

      span {
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        color: #2ACC6B;
      }

      strong {

      }
    }
  }
}

  .page-content {
    /*background-color: #e6e9ec;*/
    background-color: #fff;
  }
  .total-hours {
    margin-bottom: 30px;
    float: right;
    .in-success-history {
      border: 1px solid #d1d6d3;
      color: #333;
      padding: 5px 10px;
      float: left;
      border-bottom-left-radius: 4px !important;
      border-top-left-radius: 4px !important;
    }
    .in-interval-history {
      border: 1px solid #d1d6d3;
      color: #333;
      padding: 5px 10px;
      float: left;
      border-bottom-right-radius: 4px !important;
      border-top-right-radius: 4px !important;
    }
    .in-pause-history {
      border: 1px solid #d1d6d3;
      border-left: none;
      color: #333;
      padding: 5px 10px;
      float: left;
      border-right: none;
    }
  }

  .nowrap {
    white-space: nowrap;
  }


  .in-pause {
    position: absolute;
    right: 0;
    top: -40px;
    color: #ffffff;
    font-weight: 600;
    background: #e74a4e;
    padding: 4px 14px;
    border: 1px solid;
    -webkit-border-radius: 2px !important;
    -moz-border-radius: 2px !important;
    border-radius: 2px !important;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/userPerfil/userPerfil.vue